// extracted by mini-css-extract-plugin
module.exports = {"footerDefault":"footerDefault___CPWfH","row":"row___1mVbs","backdropLogo":"backdropLogo___2Ag2c","copyright":"copyright___-LVm-"};